import { formatCartPrice } from './cartItem';

export const getDiscountPercent = (product) => {
    const discount = Number(product?.discount);
    if (!Number.isFinite(discount) || discount <= 0) {
        return 0;
    }
    return Math.min(100, discount);
};

export const getEffectivePrice = (product) => {
    const base = Number(product?.price);
    if (!Number.isFinite(base) || base < 0) {
        return 0;
    }
    const discount = getDiscountPercent(product);
    if (discount <= 0) {
        return base;
    }
    return base * (1 - discount / 100);
};

export const hasProductDiscount = (product) => getDiscountPercent(product) > 0;

export const formatProductPrice = (product) => formatCartPrice(getEffectivePrice(product));

export const isProductAvailable = (product) => product?.availability !== false;
